var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6599 10.25L12.6599 2.24996C12.4774 2.08964 12.2428 2.00122 11.9999 2.00122C11.757 2.00122 11.5224 2.08964 11.3399 2.24996L2.33987 10.25C2.18691 10.3853 2.07904 10.5642 2.03077 10.7626C1.98251 10.961 1.99615 11.1695 2.06987 11.36C2.14239 11.5479 2.26998 11.7095 2.43592 11.8237C2.60187 11.9379 2.79843 11.9994 2.99987 12H3.99987V21C3.99987 21.2652 4.10523 21.5195 4.29277 21.7071C4.4803 21.8946 4.73466 22 4.99987 22H18.9999C19.2651 22 19.5194 21.8946 19.707 21.7071C19.8945 21.5195 19.9999 21.2652 19.9999 21V12H20.9999C21.2013 11.9994 21.3979 11.9379 21.5638 11.8237C21.7298 11.7095 21.8574 11.5479 21.9299 11.36C22.0036 11.1695 22.0172 10.961 21.969 10.7626C21.9207 10.5642 21.8128 10.3853 21.6599 10.25ZM12.9999 20H10.9999V17C10.9999 16.7347 11.1052 16.4804 11.2928 16.2928C11.4803 16.1053 11.7347 16 11.9999 16C12.2651 16 12.5194 16.1053 12.707 16.2928C12.8945 16.4804 12.9999 16.7347 12.9999 17V20ZM17.9999 20H14.9999V17C14.9999 16.2043 14.6838 15.4412 14.1212 14.8786C13.5586 14.316 12.7955 14 11.9999 14C11.2042 14 10.4412 14.316 9.87855 14.8786C9.31594 15.4412 8.99987 16.2043 8.99987 17V20H5.99987V12H17.9999V20ZM5.62987 9.99996L11.9999 4.33996L18.3699 9.99996H5.62987Z",
    fill: "#0090FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.78048b96e965ea282a99498c93a9f561.svg";
export { ForwardRef as ReactComponent };